module.exports = __webpack_public_path__ + "static/media/logo-vnda.ac489c42.svg";